import Link from 'next/link';

export default function DesktopStickyFollow({
  showHeaderSticky,
  desktopSelectors,
  DesktopSelect,
  products
}) {
  if (showHeaderSticky === true) {
    return (
      <div className="sticky-wrapper border-dawn-grey-30 fixed top-0 left-0 z-100 flex h-[88px] w-full border-b bg-white">
        <div className="px-auto max-w-container container mx-auto px-4 pb-7 sm:px-10 lg:px-16 2xl:px-0">
          <div className="grid w-full grid-cols-3 gap-x-[64px]">
            {desktopSelectors?.map((product, index) => {
              return (
                <div className="flex w-full justify-between py-5" key={index}>
                  <div className="w-full pr-2">
                    <DesktopSelect
                      product={product.productTitle}
                      index={index}
                      key={`selector-${index}`}
                      sticky={true}
                    />
                  </div>
                  <Link
                    href={`/products/${products.find((item) => item.reference[0].shopifyProduct[0].title === product.productTitle.concat(' Mattress')).reference[0].shopifyProduct[0].handle}`}
                    prefetch={false}
                  >
                    <button
                      aria-label={`Shop ${product.productTitle}`}
                      className="btn-primary body-r h-[48px] w-[120px] font-bold"
                    >
                      Shop Now
                    </button>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
